import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BaseListQuery } from '../../features/base-management/models';
import { BaseColorDto } from '../../api/scheduler/models/base-color-dto';
import { BaseDto } from '../../api/scheduler/models/base-dto';
import { BaseLeadDto } from '../../api/scheduler/models/base-lead-dto';
import { BaseCrewRowDto } from '../../api/scheduler/models/base-crew-row-dto';
import { CrewStatus } from '../../api/scheduler/models/crew-status';
import { Rank } from '../../api/scheduler/models/rank';
import { Rotation } from '../../api/scheduler/models/rotation';
import { CreateBaseShiftRequest } from '../../api/scheduler/models/create-base-shift-request';
import { SaveBaseRequest } from '../../api/scheduler/models/save-base-request';
import { UpdateBaseShiftsRequest } from '../../api/scheduler/models/update-base-shifts-request';
import { NamedColor } from '../../shared/utils/color-distance';

export const BaseManagementActions = createActionGroup({
  source: 'Base Management',
  events: {
    'Load Access': emptyProps(),
    'Load Access Success': props<{ allowed: boolean; canWrite: boolean }>(),
    'Load Access Failure': props<{ error: string }>(),
    'Load Bases': props<{ query: BaseListQuery }>(),
    'Load Bases Success': props<{ bases: BaseDto[]; totalElements: number; totalPages: number }>(),
    'Load Bases Failure': props<{ error: string }>(),
    'Load Base': props<{ id: number }>(),
    'Load Base Success': props<{ base: BaseDto }>(),
    'Load Base Failure': props<{ error: string }>(),
    'Load Lookups': emptyProps(),
    'Load Lookups Success': props<{
      leads: BaseLeadDto[];
      timeZones: string[];
    }>(),
    'Load Lookups Failure': props<{ error: string }>(),
    'Load Base Colors': emptyProps(),
    'Load Base Colors Success': props<{ colors: BaseColorDto[] }>(),
    'Load Base Colors Failure': emptyProps(),
    'Load Reserved Colors': emptyProps(),
    'Load Reserved Colors Success': props<{ colors: NamedColor[] }>(),
    'Load Reserved Colors Failure': emptyProps(),
    'Load Crew': props<{
      baseId: number;
      startDate: string;
      endDate: string;
      search?: string;
      rank?: Rank[];
      rotation?: Rotation[];
      crewStatus?: CrewStatus[];
      page?: number;
      size?: number;
    }>(),
    'Load Crew Success': props<{
      crew: BaseCrewRowDto[];
      totalElements: number;
      totalPages: number;
    }>(),
    'Load Crew Failure': props<{ error: string; forbidden?: boolean }>(),
    'Assign Crew Lead': props<{ baseId: number; crewId: number }>(),
    'Assign Crew Lead Success': props<{
      baseId: number;
      newLead: BaseLeadDto;
      previousCrewId: number | null;
    }>(),
    'Assign Crew Lead Failure': props<{ error: string }>(),
    'Revert Crew Lead': props<{ baseId: number; previousCrewId: number | null }>(),
    'Revert Crew Lead Success': props<{ baseId: number }>(),
    'Revert Crew Lead Failure': props<{ error: string }>(),
    'Create Base': props<{ request: SaveBaseRequest; imageFile?: File | null }>(),
    'Create Base Success': props<{ base: BaseDto }>(),
    'Update Base': props<{ id: number; request: SaveBaseRequest }>(),
    'Update Base Success': props<{ base: BaseDto }>(),
    'Create Shift': props<{ id: number; request: CreateBaseShiftRequest }>(),
    'Create Shift Success': props<{ base: BaseDto; shiftName: string }>(),
    'Update Shifts': props<{ id: number; request: UpdateBaseShiftsRequest }>(),
    'Update Shifts Success': props<{ base: BaseDto }>(),
    'Upload Profile Image': props<{ id: number; file: File }>(),
    'Upload Profile Image Success': props<{ id: number; profileImageUrl: string | null }>(),
    'Delete Profile Image': props<{ id: number }>(),
    'Delete Profile Image Success': props<{ id: number }>(),
    'Save Failure': props<{ error: string }>(),
  },
});
